// extracted by mini-css-extract-plugin
export default {"hidden":"PrintReview-module__hidden--hL6BV","header":"PrintReview-module__header--Mighm"};